import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProductCard } from '../shop/ui/ProductCard';
import { useProducts } from '../shop/core/hooks/useProducts';
import { Loading } from './ui/Loading';

const Gears = () => {
  const navigate = useNavigate();
  const { products, loading, error, fetchProducts } = useProducts({ 
    perPage: 4, 
    featured: true, 
    page: 1 
  });

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return (
    <section className="gears latest-section shop-page" id="gears">
      <div className="container">
        <h2 className="h2 section-title">Latest Arrivals</h2>
        {loading ? (
          <div className="flex justify-center items-center py-12">
            <Loading size="lg" text="Loading latest products..." />
          </div>
        ) : error ? (
          <div className="text-center py-12">
            <p className="text-red-400 mb-4">Error loading products: {error}</p>
            <button 
              onClick={() => fetchProducts()} 
              className="btn btn-primary"
            >
              Retry
            </button>
          </div>
        ) : (
          <div className="grid gap-2 sm:gap-6 grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {products.slice(0, 4).map((product) => (
              <ProductCard 
                key={product.id}
                product={product} 
                onViewDetails={(product) => navigate(`/shop/product/${product.id}`)}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Gears;
